import i18n from '../../i18n';

const UPPERCASE_TOKEN = /^[A-Z][A-Z0-9]*(?:[._-][A-Z0-9]+)*$/;

const fallbackKeyForStatus = (status) => {
  const normalizedStatus = Number(status);

  switch (normalizedStatus) {
    case 0:
      return 'common.error.network';
    case 401:
      return 'common.error.unauthorized';
    case 403:
      return 'common.error.forbidden';
    case 404:
      return 'common.error.notFound';
    case 405:
      return 'common.error.actionUnavailable';
    case 408:
      return 'common.error.timeout';
    case 409:
      return 'common.error.conflict';
    // One-release compatibility with the previous public contract.
    case 413:
      return 'common.error.fileTooLarge';
    case 422:
      return 'common.error.validation';
    case 429:
      return 'common.error.tooManyRequests';
    case 502:
    case 503:
    case 504:
      return 'common.error.serviceUnavailable';
    default:
      if (normalizedStatus >= 400 && normalizedStatus < 500) {
        return 'common.error.badRequest';
      }
      return 'common.error.unexpected';
  }
};

/**
 * Resolve one safe API message using the active application locale.
 *
 * Uppercase tokens are locale keys owned by the client. Unknown tokens and
 * absent messages use a localized HTTP-status fallback. Plain backend copy is
 * already the contract's safe English fallback and is therefore kept verbatim.
 */
export default function translateMessage(message, status, params = {}) {
  const normalizedMessage = typeof message === 'string' ? message.trim() : '';
  const interpolation = params && typeof params === 'object' && !Array.isArray(params)
    ? params
    : {};

  if (normalizedMessage && !UPPERCASE_TOKEN.test(normalizedMessage)) {
    return normalizedMessage;
  }

  if (normalizedMessage && i18n.exists(normalizedMessage)) {
    return i18n.t(normalizedMessage, interpolation);
  }

  return i18n.t(fallbackKeyForStatus(status), interpolation);
}

